const PLP_TEMPLATE_CONSTANTS = {
  topBannerProps: {
    imageStrategy: 'initial',
    imageStyles: { position: 'static', width: 'auto' },
  },
};

export default PLP_TEMPLATE_CONSTANTS;
